import { useMemo } from 'react';

import { useUser } from '@/features/auth/api/use-user';
import { useMembers } from '@/features/org/api/use-members';
import { isOwner } from '@/features/org/utils';

export const useOrgOwner = () => {
  const { data: creator, isLoading: isUserLoading } = useUser();
  const { data: members, isLoading: isMembersLoading } = useMembers();

  const currentMember = useMemo(
    () => members?.find((member) => member.email === creator?.email),
    [members, creator?.email],
  );

  return {
    currentMember,
    isOwner: !!currentMember && isOwner(currentMember),
    isLoading: isUserLoading || isMembersLoading,
  };
};
